/* MUI */
import { Paper } from '@mui/material';

/* Shared */
import Logs from 'application/Shared/Pages/Logs/Logs';

/* React */
import React from 'react';
import { useParams } from 'react-router';

export const UserLogs = () => {
    const { userId } = useParams();

    return (
        <Paper elevation={0} variant="outlined" data-testid="adminUserLogs">
            <Logs platformUserId={userId} subPage />
        </Paper>
    );
};
